/**
 * Prefer in-app navigation when the router bridge is registered (see RouterNavigateBridge).
 * Falls back to full navigation for external URLs or if the bridge is unavailable.
 */
export const navigateToPushLink = (link) => {
  if (!link || typeof window === 'undefined') {
    return;
  }

  const navigate = window.__routerNavigate;
  if (typeof navigate === 'function') {
    try {
      navigate(link);
      return;
    } catch (_) {
      // Fall through to location.assign
    }
  }

  window.location.assign(link);
};
